import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { CategoryWithReplyTemplate } from '@sb-tools/typescript/models/category-with-reply-template.model';
import { ReplyTemplate } from '@sb-tools/typescript/models/reply-template.model';
import { ReplyTemplatesTree } from '@sb-tools/typescript/models/reply-templates-tree.model';
import { AllReplyTemplatesModel } from '@sb-tools/typescript/models/all-reply-templates-model.model';
import { TemplateEntity } from './template-entity.model';
import { TemplateEntityType } from './template-entity-type.enum';
import { ReplyTemplateDataService } from './reply-template-data.service';

@Injectable({
    providedIn: 'root',
})
export class ReplyTemplateService {
    allReplyTemplates: (CategoryWithReplyTemplate | ReplyTemplate)[] = [];
    isReplyTemplatesLoaded: boolean;
    personalReplyTemplates: (CategoryWithReplyTemplate | ReplyTemplate)[] = [];
    personalReplyTemplatesTree: ReplyTemplatesTree;
    replyTemplates: (CategoryWithReplyTemplate | ReplyTemplate)[] = [];
    replyTemplatesTree: ReplyTemplatesTree;

    constructor(private replyTemplateDataService: ReplyTemplateDataService) {}

    refreshAllReplyTemplates(): Observable<AllReplyTemplatesModel> {
        return this.replyTemplateDataService.getAllReplyTemplates().pipe(
            tap((replyTemplates) => {
                this.setAllReplyTemplates(replyTemplates);
            }),
        );
    }

    setAllReplyTemplates({ community, personal }: AllReplyTemplatesModel): void {
        this.replyTemplatesTree = community;
        this.personalReplyTemplatesTree = personal;
        this.personalReplyTemplates = [...personal.byCategories, ...personal.global];
        this.replyTemplates = [...community.byCategories, ...community.global];
        this.allReplyTemplates = this.personalReplyTemplates.concat(this.replyTemplates);
    }

    getTemplateCategoryById(templatesList: TemplateEntity[], id: number): TemplateEntity {
        let replyTemplate;

        for (const template of templatesList) {
            if (template.id === id && template.type === TemplateEntityType.category) {
                return template;
            }

            if (template.children?.length > 0) {
                replyTemplate = this.getTemplateCategoryById(template.children, id);

                if (replyTemplate) {
                    return replyTemplate;
                }
            }
        }

        return null;
    }
}
